export const SEND_EMAIL_REQUEST_START = 'SEND_EMAIL_REQUEST_START';
export const SEND_EMAIL_REQUEST_FAIL = 'SEND_EMAIL_REQUEST_FAIL';
export const SEND_EMAIL_REQUEST_SUCCESS = 'SEND_EMAIL_REQUEST_SUCCESS';
